<template>
    <div class="pagination-component">
        <div class="pagination-buttons">
            <div :class="{'pagination-button': true,
            'pagination-button-selected': 0 === internalController.actualPage}"
                 @click="changePage(0)">{{ $t("dataTable.first") }}
            </div>

            <div v-for="(page, idx) in optionPages" :class="{'pagination-button': true,
            'pagination-button-selected': page === internalController.actualPage}"
                 @click="changePage(page)">{{page}}
            </div>

            <div :class="{'pagination-button': true,
            'pagination-button-selected': internalController.pages - 1 === internalController.actualPage}"
                 @click="changePage(internalController.pages - 1)">{{ $t("dataTable.last") }}
            </div>
        </div>
        <div>
            {{$t("dataTable.showing", {actual: internalController.actualItems, total:internalController.totalItems})}} ({{$t("dataTable.pagedBy")}}
            <div style="display: inline-block; width: 50px;">
                <form-number-input v-model="internalController.pageSize"/>
            </div>
            )
        </div>
    </div>
</template>

<script>
    import FormTextInput from "./form/FormTextInput";
    import _ from 'lodash'
    import FormSelectInput from "./form/FormSelectInput";
    import FormNumberInput from "./form/FormNumberInput";

    export default {
        name: "Paginator",
        components: {FormNumberInput, FormSelectInput, FormTextInput},
        props: {
            pagination: {
                type: Object
            }
        },
        data: function () {
            return {
                internalController: {
                    pages: 10,
                    actualPage: 0,
                    pageSize: 10,
                    actualItems: Number.NaN,
                    totalItems: Number.NaN
                }
            }
        },
        methods: {
            changePage: _.debounce(function(page, pageSize) {
                this.$emit("pageChanged", page, pageSize);
            }, 500)
        },
        computed: {
            optionPages() {
                if (this.internalController.pages <= 5)
                    return [...Array(this.internalController.pages).keys()];
                let offset = [-2, -1, 0, 1, 2];
                offset = offset.map(v => v + this.internalController.actualPage);
                offset = offset
                    .map(v => offset[0] < 0 ? Math.abs(offset[0]) + v : v)
                    .map(v => offset[4] > this.internalController.pages ? v - (offset[4] - this.internalController.pages + 1) : v);
                return offset;
            }
        },
        watch: {
            pagination: {
                handler(newVal) {
                    this.internalController = newVal;
                },
                immediate: true
            },
            'internalController.pageSize': {
                handler(newVal) {
                    this.internalController.pageSize = +newVal;
                    if(newVal > 0 && newVal !== this.pageSize) {
                        this.changePage(this.actualPage, this.internalController.pageSize);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/global";

    .pagination-component {
        display: grid;
        grid-template-columns: auto fit-content(100%);

    }

    .pagination-buttons {
        flex-flow: row;
        align-items: center;
        justify-content: center;
    }

    .pagination-button {
        display: inline-flex;
        padding: 2px 4px 2px 4px;
        background-color: $navigationGray;
        margin: 0px 4px 0px 4px;
        cursor: pointer;
        user-select: none;
    }

    .pagination-button-selected {
        background-color: $openRed !important;
        color: inherit !important;
        cursor: default;
    }

    .pagination-button:hover {
        background-color: lighten($openRed, 15);
        color: $navigationGray;
    }

</style>